import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-assets-v2",
  "use": "icon-assets-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-assets-v2\"><path d=\"M20 21a1 1 0 0 1-2 0v-2H6v2a1 1 0 0 1-2 0v-8.764c0-.155.036-.308.106-.447L5 10l.89-7.124A1 1 0 0 1 6.883 2h10.234a1 1 0 0 1 .992.876L19 10l.894 1.789c.07.139.106.292.106.447V21zM9 14H6v3h3v-3zm9 0h-3v3h3v-3zm-1-8H7v4h10V6zM3 5a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm18 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1z\" fill=\"#A4B4D0\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol